/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are quartiles calculated?`)
};

const es_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calculan los cuartiles?`)
};

const de_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Quartile berechnet?`)
};

const nl_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden kwartielen berekend?`)
};

const fr_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les quartiles sont-ils calculés ?`)
};

const it_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono calcolati i quartili?`)
};

const pt_br2_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como os quartis são calculados?`)
};

const pt_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são calculados os quartis?`)
};

const ja_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四分位数はどう計算されますか？`)
};

const zh_box_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四分位数是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_faq_q3", locale)
	if (locale === "en") return en_box_faq_q3(inputs)
	if (locale === "es") return es_box_faq_q3(inputs)
	if (locale === "de") return de_box_faq_q3(inputs)
	if (locale === "nl") return nl_box_faq_q3(inputs)
	if (locale === "fr") return fr_box_faq_q3(inputs)
	if (locale === "it") return it_box_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_box_faq_q3(inputs)
	if (locale === "pt") return pt_box_faq_q3(inputs)
	if (locale === "ja") return ja_box_faq_q3(inputs)
	return zh_box_faq_q3(inputs)
};